module.exports = __webpack_public_path__ + "static/img/icon_shop_cost.5d6c3aae.png";